import { useTranslation } from "react-i18next";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogAction,
} from "@/shared/components/ui/alert-dialog";
import { useSession } from "@/shared/auth/SessionContext";

export function SessionTerminatedOverlay() {
  const { t } = useTranslation("session");
  const { logout } = useSession();

  return (
    <AlertDialog open>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("terminated.title")}</AlertDialogTitle>
          <AlertDialogDescription>
            {t("terminated.description")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={logout}>
            {t("terminated.signInAgain")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
